import { postRequest, putRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const bundleList = async (data, accountId) => {
  try {
    return await postRequest(`${urls.BUNDLE_LIST}/${accountId}`, data);
  } catch (err) {
    return err;
  }
};
export const deleteBundle = async (data) => {
  try {
    return await putRequest(`${urls.DELETE_VEHICLES}`, data);
  } catch (err) {
    return err;
  }
};
